export default __webpack_public_path__ + "static/media/BenjaminPhoto.a2ea6484.jpg";